module.exports = __webpack_public_path__ + "img/mail.52d42129.svg";